import { PODS, PULSE_COLORS } from './pulseConfig.js'
import { podNameToKey } from './pulseHelpers.js'

const POD_COLOR_PALETTE = [
    { color: '#3B82F6', bg: '#1E3A8A' },
    { color: '#10B981', bg: '#064E3B' },
    { color: '#A78BFA', bg: '#4C1D95' },
]
const POD_COLOR_CONFIG = Object.values(PODS).map((p, i) => ({
    key: p.key,
    label: p.name.toUpperCase(),
    ...POD_COLOR_PALETTE[i],
}))
const OTHER_POD_CONFIG = { key: 'OTHER', label: 'OTHER', color: '#F59E0B', bg: '#78350F' }

export default function AutomationCorner({ data, selectedPod, headerAction, embedded = false }) {
    const selectedPodKey = selectedPod !== 'all' ? podNameToKey(selectedPod) : undefined
    const displayPodConfig = selectedPodKey
        ? POD_COLOR_CONFIG.filter((p) => p.key === selectedPodKey)
        : [...POD_COLOR_CONFIG, OTHER_POD_CONFIG]
    const filteredByPod = selectedPodKey ? data.byPod.filter((p) => p.podKey === selectedPodKey) : data.byPod
    const displayTotal = filteredByPod.reduce((sum, p) => sum + p.automated, 0)
    const gridTemplateColumns = selectedPodKey ? 'repeat(2, minmax(0, 1fr))' : 'repeat(auto-fit, minmax(88px, 1fr))'

    return (
        <div
            style={{
                background: embedded ? '#33415566' : PULSE_COLORS.cardBg,
                borderRadius: embedded ? '8px' : '12px',
                padding: embedded ? '16px' : '20px',
                border: `1px solid ${PULSE_COLORS.border}`,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    marginBottom: '16px',
                }}
            >
                <div>
                    {embedded ? (
                        <p
                            style={{
                                color: PULSE_COLORS.textMuted,
                                fontSize: '11px',
                                fontWeight: 700,
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                margin: 0,
                            }}
                        >
                            Automated Stories + Bugs By Pod
                        </p>
                    ) : (
                        <h3 style={{ color: PULSE_COLORS.text, fontWeight: 600, fontSize: '16px', margin: 0 }}>
                            Automation Corner
                        </h3>
                    )}
                    <p
                        style={{
                            color: PULSE_COLORS.textMuted,
                            fontSize: '13px',
                            margin: embedded ? '4px 0 0' : '6px 0 0',
                        }}
                    >
                        Counts Jira Story and Bug issues marked with Automation Status = Automated.
                    </p>
                </div>
                {headerAction}
            </div>

            {!embedded && (
                <p
                    style={{
                        color: PULSE_COLORS.textMuted,
                        fontSize: '11px',
                        fontWeight: 700,
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        margin: '0 0 12px',
                    }}
                >
                    Automated Stories + Bugs By Pod
                </p>
            )}

            <div style={{ display: 'grid', gridTemplateColumns, gap: '16px' }}>
                {displayPodConfig.map((pod) => {
                    const podData = filteredByPod.find((p) => p.podKey === pod.key)
                    return (
                        <div key={pod.key} style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '36px', fontWeight: 700, color: pod.color }}>
                                {podData?.automated ?? 0}
                            </div>
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    marginTop: '4px',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    fontWeight: 700,
                                    backgroundColor: pod.bg,
                                    color: pod.color,
                                }}
                            >
                                {pod.label}
                            </span>
                            <p
                                style={{
                                    color: PULSE_COLORS.textSubtle,
                                    fontSize: '11px',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.06em',
                                    margin: '4px 0 0',
                                }}
                            >
                                Automated
                            </p>
                        </div>
                    )
                })}
                <div
                    style={{
                        textAlign: 'center',
                        borderLeft: `1px solid ${PULSE_COLORS.border}`,
                        paddingLeft: '12px',
                    }}
                >
                    <div style={{ fontSize: '36px', fontWeight: 700, color: PULSE_COLORS.success }}>{displayTotal}</div>
                    <span
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            marginTop: '4px',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '11px',
                            fontWeight: 700,
                            backgroundColor: '#064E3B',
                            color: PULSE_COLORS.success,
                        }}
                    >
                        TOTAL
                    </span>
                    <p
                        style={{
                            color: PULSE_COLORS.textSubtle,
                            fontSize: '11px',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.06em',
                            margin: '4px 0 0',
                        }}
                    >
                        Automated
                    </p>
                </div>
            </div>
        </div>
    )
}
